import { render } from "./OverlayFrame.vue?vue&type=template&id=b6ada4c2"
import script from "./OverlayFrame.vue?vue&type=script&lang=js"
export * from "./OverlayFrame.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matthew/Documents/Vault/code/sal/malum/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__